import React from 'react';
import { howItWorks } from '../../data/mock';

const HowItWorksSection = () => {
  return (
    <section className="py-12 md:py-16 section-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="inline-block text-[#B5D43B] font-semibold text-sm tracking-wider uppercase mb-4">
            Our Process
          </span>
          <h2 className="heading-2 mb-5">
            How It Works
          </h2>
          <p className="body-large">
            We make the process simple and stress-free. Here's what to expect 
            when you choose Supa Energy Hub.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {howItWorks.map((step, index) => (
            <div key={step.step} className="relative">
              {/* Connector Line (hidden on last item and small screens) */}
              {index < howItWorks.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(100%+1rem)] w-8 h-0.5 bg-[#B5D43B]/30" />
              )}
              
              <div className="bg-white rounded-2xl p-6 border border-black/5 h-full">
                {/* Step Number */}
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#B5D43B] to-[#9EC22A] flex items-center justify-center mb-5">
                  <span className="text-[#3D5A47] font-bold text-lg">{step.step}</span>
                </div>
                
                {/* Content */}
                <h3 className="font-semibold text-lg text-[#3D5A47] mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
